// 9fbef606107a605d69c0edbcd8029e5d

const drawBalloon = (ctx, size, colors) => {
  ctx.beginPath();
  ctx.ellipse(size, size, size / 2, size, 0, 0, Math.PI * 2);
  ctx.fillStyle = colors;
  ctx.fill();
  ctx.closePath();
  ctx.beginPath();
  ctx.moveTo(size, size * 2);
  ctx.lineTo(size, size * 3);
  ctx.strokeStyle = '#444';
  ctx.stroke();
};

export default drawBalloon;
